import { createFileRoute } from '@tanstack/react-router'

import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'
import { useCurrentOrganization } from '@/stores/organization.store'
import { AttachmentLibrarySettings } from '@/components/attachments/attachment-library-settings'
import { SkeletonBar } from '@/components/shared/skeleton-bar'

export const Route = createFileRoute('/_app/_settings/attachment-library')({
  component: AttachmentLibraryPage,
})

function AttachmentLibraryPage() {
  useBreadcrumbFromRoute()
  const { currentOrganization, isLoading } = useCurrentOrganization()

  return (
    <div className="flex flex-col gap-4 p-6">
      {isLoading || !currentOrganization ? (
        <div className="space-y-4">
          <SkeletonBar className="h-8 w-64" />
          <SkeletonBar className="h-4 w-96" />
          <SkeletonBar className="h-48 w-full" />
        </div>
      ) : (
        <AttachmentLibrarySettings organizationId={currentOrganization.id} />
      )}
    </div>
  )
}
